// features/credential.fields.js

export const getCredentialFields = (isEditing = false) => [
  {
    name:      "api_key",
    label:     isEditing ? "API Key (leave blank to keep current)" : "API Key",
    type:      "password",
    required:  !isEditing,
    fullWidth: true,
  },
  {
    name:     "per_day_limit",
    label:    "Per Day Limit",
    type:     "number",
    required: true,
    min:      100,
  },
  {
    name:     "total_mail_limit",
    label:    "Total Mail Limit",
    type:     "number",
    required: true,
    min:      1,
  },
  {
    name:     "plan_expiry_date",
    label:    "Plan Expiry Date",
    type:     "date",
    required: false,
  },
  {
    name:     "reminder_days_before",
    label:    "Reminder Days Before Expiry",
    type:     "number",
    required: false,
    min:      1,
    max:      365,
  },
  {
    name:         "is_domain_verified",
    label:        "Domain Verified",
    type:         "boolean",
    defaultValue: false,
  },
  {
    name:         "is_activated",
    label:        "Active",
    type:         "boolean",
    defaultValue: true,
  },
];
